import {LIMPAR_RELATORIO_ITINERARIOS} from '../types'

export default function limparRelatorioItinerarios () {
  return {
    type: LIMPAR_RELATORIO_ITINERARIOS,
  }
}
